module.exports = __webpack_public_path__ + "img/the-dragon-republic.371bc8ca.png";